module.exports = __webpack_public_path__ + "img/stapelmuurtje bouwen copy.a284b3ba.jpg";